var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nf-card",style:({ width: _vm.width })},[_c('div',{staticClass:"nf-card_box",class:{
      'nf-card_box_shadow': _vm.shadow,
    },style:({
      'border-width': _vm.borderSize,
      'border-radius': _vm.round,
      backgroundColor: _vm.bgColor,
      'border-style': _vm.border,
      'border-color': _vm.borderColor,
      padding: _vm.padding,
    })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }